import type { AuthService } from './authentication/auth.service';

export function init_app(authService: AuthService) {
  return () => authService.load();
}
